import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useHistory, useLocation } from 'react-router';
import { IssueType } from '../../../../../../../typings/Issue.interface';
import LINKS from '../../../../configs/links';
import { fieldName, stringifyQuery } from '../../../../utils';
import { issue_type_configs } from '../../../../utils/issues';
import Button, { ClickableArea } from '../../../common/base/Button';
import { IconName } from '../../../common/base/Icon';
import Tabs from '../../../common/base/Tabs';
import Dropdown from '../../../common/Dropdown';
import CheckboxInput from '../../../common/Form/Fields/CheckboxInput';
import { Div } from '../../../common/helpers/StyledUtils';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavActions, StyledViewNavHeader, StyledViewNavSecondary, ViewTitle } from '../../../layouts/ViewLayout';
import TriggersList from './IssueTriggersList';
const issue_types = Object.keys(issue_type_configs) as IssueType[];
const issue_trigger_status_options = {
  enabled: {
    label: 'Enabled',
    icon: 'notification'
  },
  disabled: {
    label: 'Disabled',
    icon: 'notification_off'
  }
};
const IssueTriggersListView: React.FC = () => {
  const $ = _c(37);
  const history = useHistory();
  const location = useLocation();
  let t0;
  if ($[0] !== location.pathname) {
    const path_issue_type = location.pathname.split("/")[2]?.split("#")[0];
    const fallback_path_issue_type = location.pathname.split("/")[3]?.split("#")[0];
    t0 = issue_types.includes(path_issue_type as IssueType) ? path_issue_type : issue_types.includes(fallback_path_issue_type as IssueType) ? fallback_path_issue_type : "delivery";
    $[0] = location.pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const issue_type = t0;
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  const status = query.status;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ViewTitle title="Issue Triggers" tooltip="Issue triggers allow you to determine alert preferences for Delivery, Transformation, Backpressure, and Request problems in your project." link={LINKS.product_docs.issue_triggers} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== status) {
    t2 = status ? status.reduce(_temp, {}) : {};
    $[3] = status;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = {
      status: t2
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== updateSearchQuery) {
    t4 = values => {
      const status_0 = Object.entries(values.status).filter(_temp2).map(_temp3) as ('enabled' | 'disabled')[];
      updateSearchQuery({
        status: status_0.length > 0 ? status_0 : undefined
      });
    };
    $[7] = updateSearchQuery;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== status) {
    t5 = t6 => {
      const {
        submitForm
      } = t6;
      return <Dropdown w={{
        px: 184
      }} icon="filter_list" label="Trigger status" expand_icon="chevron_down" outline={true} badge={status?.length ? {
        label: status.length.toString()
      } : undefined} onToggle={() => {
        submitForm();
      }}><Form><Div p={1}>{Object.entries(issue_trigger_status_options).map(_temp4)}</Div></Form></Dropdown>;
    };
    $[9] = status;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <Formik initialValues={t3} onSubmit={t4}>{t5}</Formik>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = `/issue-triggers/${issue_type}/create/${issue_type}`;
  let t8;
  if ($[15] !== t7) {
    t8 = <Button.Permission role="member" icon="add_circle" to={t7}>Create issue trigger</Button.Permission>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <StyledViewNavHeader>{t1}<StyledViewNavActions>{t6}{t8}</StyledViewNavActions></StyledViewNavHeader>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = issue_type as string;
  let t11;
  if ($[20] !== history || $[21] !== query.status || $[22] !== status) {
    t11 = tab => {
      const query_params = query?.status ? `?${stringifyQuery({
        status
      })}` : "";
      history.push(`/issue-triggers/${tab}${query_params}`);
    };
    $[20] = history;
    $[21] = query.status;
    $[22] = status;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = Object.entries(issue_type_configs).map(_temp5);
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11) {
    t13 = <StyledViewNavSecondary><Tabs active_tab={t10} onTabSelected={t11} border={false} tabs={t12} /></StyledViewNavSecondary>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t9) {
    t14 = <StyledViewNav>{t9}{t13}</StyledViewNav>;
    $[28] = t13;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = issue_type as IssueType;
  let t16;
  if ($[31] !== status || $[32] !== t15) {
    t16 = <TriggersList type={t15} status={status} />;
    $[31] = status;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t14 || $[35] !== t16) {
    t17 = <StyledViewLayout><StyledViewContent>{t14}{t16}</StyledViewContent></StyledViewLayout>;
    $[34] = t14;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
};
export default IssueTriggersListView;
function _temp(obj, key) {
  return {
    ...obj,
    [key]: true
  };
}
function _temp2(t0) {
  const [, value] = t0;
  return value;
}
function _temp3(t0) {
  const [key_0] = t0;
  return key_0;
}
function _temp4(t0) {
  const [key_1, config] = t0;
  const fieldId = fieldName(key_1, "status");
  return <ClickableArea key={key_1} rounded={true}><CheckboxInput label={config.label} icon={config.icon as IconName} name={fieldId} p={{
      y: 1.5,
      x: 2
    }} /></ClickableArea>;
}
function _temp5(t0) {
  const [key_2, issue_type_0] = t0;
  return {
    ...issue_type_0,
    key: key_2
  };
}